import React from "react";
import TermsAndConditionsModal from "./TermsAndConditionsModal";

const POTermsAndCondition = ({ isViewMode, isPOData, isEditMode, errors }) => {
  return (
    <div className="p-4 bg-white">
      {isViewMode ? (
        <>
          <div className="mb-1 flex items-center gap-2 ">
            <h3 className="text-lg font-semibold text-gray-800">
              Terms & Conditions
            </h3>
          </div>

          <div className="space-y-1 ">
            {
              <div className="flex gap-1   p-2">
                <div>
                  {/* <h4>{isPOData?.tandc_name}</h4> */}

                  <p className="whitespace-pre-line text-base text-gray-700">
                    {isPOData?.tandc_desc}
                  </p>
                </div>
              </div>
            }
          </div>
          {/* 
          <div className="space-y-1 ">
            {isPOData?.termsAndConditionsId?.map((term, index) => (
              <div key={term._id} className="flex gap-1   p-2">
                <span>{index + 1}.</span>
                <div>
                  <h4 className="">{term.title}</h4>

                  <p className="mt-2 whitespace-pre-line text-sm text-gray-700">
                    {term.description}
                  </p>
                </div>
              </div>
            ))}
          </div> */}
          <div className=" flex items-center gap-2">
            <h3 className="text-lg font-semibold text-gray-800">
              Payment Terms
            </h3>
          </div>

          <div className="rounded-md  p-2 m-2">
            <p className="whitespace-pre-line text-base leading-7 text-gray-700">
              {isPOData?.payment_terms_name}
            </p>

            {/* <div className="mb-2 inline-flex rounded-full bg-green-100 px-3 py-1 text-sm font-medium text-green-700">
              Payment Due in {isPOData?.paymentTermId?.days || 0} Days
            </div> */}

            <p className="whitespace-pre-line text-base leading-7 text-gray-700">
              {isPOData?.paymentTermId?.description}
            </p>
          </div>
        </>
      ) : (
        <></>
        //         <>
        //           <div className="grid gap-6 md:grid-cols-2 p-4">
        //             <div className="w-full">
        //               <label className="mb-2 block text-lg font-semibold">
        //                 {" "}
        //                 Payment Terms{" "}
        //               </label>{" "}
        //               <button
        //                 type="button"
        //                 onClick={() => setOpenPaymentModal(true)}
        //                 className="
        //     flex
        //     w-full
        //     items-center
        //     justify-between
        //     rounded-md
        //     border
        //     border-gray-300
        //     bg-white
        //     p-3
        //     text-left
        //   "
        //               >
        //                 <span>
        //                   {selectedPaymentTerm?.title || "Select Payment Term"}
        //                 </span>

        //                 <span>▼</span>
        //               </button>
        //               {errors.paymentTermId && (
        //                 <p className="mt-1 text-sm text-red-500">
        //                   {errors.paymentTermId}
        //                 </p>
        //               )}
        //             </div>
        //             <TermsAndConditionsModal
        //               setOpenTCModal={setOpenTCModal}
        //               isPOData={isPOData}
        //               newTC={newTC}
        //               setNewTC={setNewTC}
        //               openTCModal={openTCModal}
        //               setOpenCreateTCModal={setOpenCreateTCModal}
        //               toggleTerm={toggleTerm}
        //               openCreateTCModal={openCreateTCModal}
        //               createTermsCondition={createTermsCondition}
        //               disableButtonCheck={disableButtonCheck}
        //               isAllTermsAndConditions={isAllTermsAndConditions}
        //               errors={errors}
        //             />
        //           </div>

        //           <div className="bg-gray-50 p-6">
        //             <button
        //               className="
        //             rounded-md
        //             bg-blue-600
        //             px-8
        //             py-3
        //             font-medium
        //             text-white
        //             transition
        //             hover:bg-blue-700
        //           "
        //               onClick={isEditMode ? handleUpdatePO : handleGeneratePO}
        //             >
        //               {isEditMode ? "Edit PO" : "Generate PO"}
        //             </button>
        //           </div>
        //         </>
      )}
    </div>
  );
};

export default POTermsAndCondition;
